export const LOCAL_STORE_SESSIONS = 'sessions';
export const LOCAL_STORE_CURRENT_SESSION = 'current_session';
export const LOCAL_STORE_AUTH = 'auth';
